export enum EEventMessageType {
  DELETE_DRAWING = 'DELETE_DRAWING',
  COMPLETE_DRAWING = 'COMPLETE_DRAWING',
  SELECT_DRAWING_TOOL = 'SELECT_DRAWING_TOOL',
  OPEN_DRAWING = 'OPEN_DRAWING',
  REMOVE_DRAWING = 'REMOVE_DRAWING',
  OPEN_CONTEXT_MENU = 'OPEN_CONTEXT_MENU',
  RESET = 'RESET',
  PERIOD = 'PERIOD',
  SERIES = 'SERIES',
  STATUS = 'STATUS',
  SYMBOLS = 'SYMBOLS',
  INDICATOR = 'INDICATOR',
  TRACK_ORDER = 'TRACK_ORDER',
  THEME_SCHEME = 'THEME_SCHEME',
  CANCEL_TRACKER_ORDER = 'CANCEL_TRACKER_ORDER',
  UPDATE_TRACK_ORDER_PRICES = 'UPDATE_TRACK_ORDER_PRICES',
  BATCH_CANCEL_TRACKER_ORDER = 'BATCH_CANCEL_TRACKER_ORDER',
  ASK_PRICE_VISIBLE = 'ASK_PRICE_VISIBLE',
  EDIT_TRACK_ORDER_PRICE = 'EDIT_TRACK_ORDER_PRICE',
  REVERT_EDIT_TRACK_ORDER_PRICE = 'REVERT_EDIT_TRACK_ORDER_PRICE',
  SCROLL_TO_LATEST = 'SCROLL_TO_LATEST',
  OPEN_INDICATOR_CONFIG = 'OPEN_INDICATOR_CONFIG',
  UPDATE_INDICATOR_CONFIG = 'UPDATE_INDICATOR_CONFIG',
  TOKEN = 'TOKEN',
  CLOSE_ORDER = 'CLOSE_ORDER',
  RESIZE = 'RESIZE',
  SYMBOL_CHART_DATA = 'SYMBOL_CHART_DATA',
  SYMBOL_FEED = 'SYMBOL_FEED',
  CHART_FEED = 'CHART_FEED',
  CHART_PATCH = 'CHART_PATCH',
  CHART_LOAD = 'CHART_LOAD',
  SET_SYMBOL = 'SET_SYMBOL',
  CHART_FETCH_MORE = 'CHART_FETCH_MORE',
  ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR',
  UPDATE_CANDLESTICK_COLOR = 'UPDATE_CANDLESTICK_COLOR',
  LANGUAGE = 'LANGUAGE',

  // Trading view specific events
  IS_NATIVE = 'IS_NATIVE',
  TV_SET_PERIOD = 'TV_SET_PERIOD',
  TV_TOGGLE_INDICATORS = 'TV_TOGGLE_INDICATORS',
  TV_CHANGE_THEME = 'TV_CHANGE_THEME',
  TV_SET_INITIAL_CONFIGS = 'TV_SET_INITIAL_CONFIGS',
  TV_SET_LANGUAGE = 'TV_SET_LANGUAGE'
}
